import i18next from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import api from '../api/api';
// import api from '../api/ax';

const RevistaService = {
  retrieveYears: () =>
    trackPromise(api.post('/rest/revista/es/get/active/years')),
  //
  retrieveRevistas: (params: number) =>
    trackPromise(
      api.post(
        `/rest/revista/${i18next.language}/get/revistas/year?year=${params}`,
      ),
    ),
  //
  revistasDownload: (url: string) =>
    trackPromise(api.get(url, { responseType: 'blob' })),
  retrieveRevistasActual: (year: number, month: number) =>
    trackPromise(
      api.post(
        `/rest/revista/${i18next.language}/get/revista/year/month`,
        JSON.stringify({ month, year }),
      ),
    ),
};
export default RevistaService;
